<template>
  <b-card no-body class="p-0">

    <!-- Configuración del componente de destino -->
    <div class="bg-light m-0 p-2">
      <div class="text-center font-weight-bold">
        <i class="fa fa-plus-circle" /> Configuración del componente de destino
      </div>
      <br>
      <div class="d-flex align-items-center">
        <h2><b-badge class="bg-white"><i class="fa fa-search text-info" /></b-badge></h2>
        <div class="ml-2">
          <div>
            <strong>Componente</strong>
            <span class="ml-2">{{ destineComponent.name }}</span>
          </div>
          <div>
            <strong>CAS</strong>
            <span class="ml-2">{{ destineComponent.cas }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulario -->
    <b-form class="p-3" @submit.prevent="onHandleApplyAndUseComponent()" name="componentes-form"
      data-vv-scope="form-create-component" ref="contenedor-componentes">

      <b-row>

        <b-col md="3" sm="12">
          <!-- Visible -->
          <b-form-group>
            <b-form-checkbox @change="onHandleChangePercentSymbolFrom" v-model="formComponent.visible" :value="1"
              :unchecked-value="0">
              Visible
            </b-form-checkbox>
          </b-form-group>
          <!-- Subproducto -->
          <b-form-group>
            <b-form-checkbox v-model="formComponent.subproduct" :value="1" :unchecked-value="0">
              Subproducto
            </b-form-checkbox>
          </b-form-group>
          <!-- Rango Porcentaje -->
          <b-form-group label="">
            <b-form-checkbox v-model="formComponent.percentaje_range" :value="1" :unchecked-value="0">
              Rango Porcentaje
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <b-col md="9" sm="12">
          <b-row>

            <!-- Componente base -->
            <b-col md="6" sm="12">
              <b-form-group>
                <label for="component">Componente base</label>
                <el-select v-model="formComponent.id" name="component" @change="onHandleChangeComponentBase">
                  <el-option v-for="(component, index) in components" :key="index"
                    :label="getDataNameComponent(component)" :value="component.id"></el-option>
                </el-select>
                <span class="text-danger span-error small">
                  {{ errors.first('form-create-component.component') }}
                </span>
              </b-form-group>
            </b-col>

            <!-- Nombre Personalizado -->
            <b-col md="6" sm="12">
              <b-form-group>
                <label for="custom_component">Nombre Personalizado</label>
                <b-form-input type="text" name="custom_component" v-model="formComponent.custom_component"
                  style="height: 40px;" />
              </b-form-group>
            </b-col>

            <!-- Símbolo desde -->
            <b-col md="3" sm="12">
              <b-form-group>
                <label for="percentaje_symbol_from">Símbolo desde</label>
                <el-select v-model="formComponent.percentaje_symbol_from" name="percentaje_symbol_from" v-validate="{
                  rules: {
                    required: formComponent.visible == 1,
                  },
                }" data-vv-as=" " no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan">
                  <el-option v-for="symbol in symbols" :key="symbol.id" :label="symbol.nombre"
                    :value="symbol.nombre"></el-option>
                </el-select>
                <span class="text-danger span-error small">
                  {{ errors.first('form-create-component.percentaje_symbol_from') }}
                </span>
              </b-form-group>
            </b-col>

            <!-- Porcentaje desde -->
            <b-col md="3" sm="12">
              <b-form-group>
                <label for="percentaje_from">% Desde</label>
                <b-form-input type="text" style="height: 40px;"
                  onkeypress="if(event.keyCode < 46 || event.keyCode > 57 || event.keyCode == 47) event.returnValue = false;"
                  name="percentaje_from" v-validate="{
                    rules: {
                      required: formComponent.percentaje_range == 1,
                    },
                  }" data-vv-as=" " v-model="formComponent.percentaje_from" placeholder="Porcentaje: 10%" />
                <span class="text-danger span-error small">
                  {{ errors.first('form-create-component.percentaje_from') }}
                </span>
              </b-form-group>
            </b-col>

            <!-- Símbolo hasta -->
            <b-col md="3" sm="12">
              <b-form-group>
                <label for="percentaje_symbol_until">Símbolo hasta</label>
                <el-select v-model="formComponent.percentaje_symbol_until" name="percentaje_symbol_until"
                  no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan">
                  <el-option v-for="symbol in symbols" :key="symbol.id" :label="symbol.nombre"
                    :value="symbol.nombre"></el-option>
                </el-select>
              </b-form-group>
            </b-col>

            <!-- Porcentaje hasta -->
            <b-col md="3" sm="12">
              <b-form-group>
                <label for="percentaje_until">% hasta</label>
                <b-form-input type="text" style="height: 42px;"
                  onkeypress="if(event.keyCode < 46 || event.keyCode > 57 || event.keyCode == 47) event.returnValue = false;"
                  v-model="formComponent.percentaje_until" name="percentaje_until" data-vv-as=" "
                  placeholder="Porcentaje hasta: 1%" v-validate="{
                    rules: {
                      required: formComponent.percentaje_range == 1,
                    },
                  }" />
                <span class="text-danger span-error small">
                  {{ errors.first('form-create-component.percentaje_until') }}
                </span>
              </b-form-group>
            </b-col>

            <b-col md="12" sm="12">
              <div class="d-flex align-items-center justify-content-end">
                <b-button type="submit" variant="info" class="text-white">
                  Aplicar y usar componente
                  <i class="fa fa-check ml-1"></i>
                </b-button>
              </div>
            </b-col>

          </b-row>
        </b-col>

      </b-row>

    </b-form>
  </b-card>
</template>

<script>

// Importaciones generales
import { mapMutations, mapState } from "vuex";

export default {
  name: 'modalCreateProductComponent',
  props: {
    components: {
      type: Array,
      default: () => [],
      required: false
    },
    destineComponent: {
      type: Object,
      default: () => [],
      required: false
    }
  },
  data() {
    return {
      symbols: [
        {
          id: 1,
          nombre: '=',
        },
        {
          id: 2,
          nombre: '>',
        },
        {
          id: 3,
          nombre: '<',
        },
        {
          id: 4,
          nombre: '>=',
        },
        {
          id: 5,
          nombre: '<=',
        },
      ],
      formComponent: {
        active: null,
        custom_component: null,
        id: null,
        percentaje_from: null,
        percentaje_range: null,
        percentaje_symbol_from: null,
        percentaje_symbol_until: null,
        percentaje_until: null,
        prod_component_id: null,
        prod_product: null,
        prod_product_id: null,
        subproduct: null,
        sys_user_id: null,
        visible: 1,
        visible_company: null
      },
    }
  },

  created() {
    this.selectedComponent(true, null)
  },

  computed: {

    ...mapState('nuevocas', {
      componentsAll: 'componentes'
    }),

    ...mapState('unifyComponents', [
      'currentUnifyComponent'
    ]),

  },

  methods: {

    ...mapMutations('unifyComponents', {
      setCurrentUnifyComponent: 'setCurrentUnifyComponent',
    }),


    onHandleChangePercentSymbolFrom() {
      if (this.formComponent.visible == 0) {
        this.formComponent.percentaje_symbol_from = null
      }
      else this.formComponent.percentaje_symbol_from = '='
    },

    getDataNameComponent(component) { 
      let baseName = component.cas + ' ' + component.name
      if (component.custom_component) {
        baseName += ' (' + component.custom_component + ')'
      }

      return baseName
    },

    async onHandleChangeComponentBase(componentId) {
      this.selectedComponent(false, componentId)
    },

    selectedComponent(initialLoad = false, componentId = null) {

      if (initialLoad && typeof this.components === 'object' && this.components.length > 0) {
        this.formComponent = {
          ...this.components[0],
          id: this.components[0].id,
          component: this.components[0].component,
          percentaje_range: this.components[0].percentaje_symbol_until ? 1 : 0
        }

        this.updateComponentInComponentsProduct();
        return
      }

      if (!componentId) return

      const find = this.components.find(x => x.id == componentId)
      if (!find) return

      this.formComponent = {
        ...find,
        id: find.id,
        component: find.component,
        percentaje_range: find.percentaje_symbol_until ? 1 : 0
      }
      this.updateComponentInComponentsProduct();

    },

    updateComponentInComponentsProduct() {
      /* const index = this.components.findIndex(x => x.id == this.formComponent.id)
      this.components[index] = this.formComponent */
    },

    async onHandleApplyAndUseComponent() {
      this.$validator
          .validateAll('form-create-component')
          .then(async (result) => {
            if (result) {

              // Eliminar el componente base anterior
              let new_components = this.currentUnifyComponent.new_components.filter(x => x.prod_product_id != this.formComponent.prod_product_id)

              // Agregar el componente
              new_components.push(this.formComponent)

              const updatedProducts = Object.fromEntries(
                Object.entries(this.currentUnifyComponent.affected_products).map(([productId, components]) => {

                  components = components.map(component => {

                    const existModified = new_components.find(x => (x.id == component.id && x.prod_product_id == productId));

                    return existModified ? existModified : component;
                  });

                  if (productId == this.formComponent.prod_product_id) {

                    // Modificar los componentes si corresponde
                    const updatedComponents = components.map(component => component.id === this.formComponent.id ? this.formComponent : component);

                    return [productId, updatedComponents];
                  }

                  // Si no coincide, devolver los componentes originales
                  return [productId, components];
                })
              );

              this.setCurrentUnifyComponent({ ...this.currentUnifyComponent, new_components, affected_products: updatedProducts });
              this.$alertSuccess('Componente aplicado correctamente');
            }
          })
    },

  }

}
</script>

<style scoped></style>
